module.exports = __webpack_public_path__ + "img/h5_screenshot_regular.06a7d110.jpg";